<template>
  <div class="image-hover-module">
    <div v-for="(item, index) in finalItems" :key="index" class="item">
      <div class="image-container">
        <!-- 静默展示的图片 -->
        <div>
          <img :src="item.default" class="default-img" :alt="item.default" />
        </div>

        <!-- 悬停展示的图片 -->
        <div>
          <img :src="item.hover" class="hover-img" :alt="item.hover" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ImageHoverModule",
    props: {
      imgUrl: {
        type: Object,
        default: {}, // 默认空数组
      },
      defaultImages: {
        type: Array,
        default: () => []
      },
      hoverImages: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      finalItems() {
        const curUrl = this.imgUrl?.url.replace(/\/$/, '')
         // const curUrl='http://127.0.0.1'
        // 1. 组合数据，最多取5个
        const combined = this.defaultImages.slice(0, 5).map((defaultImg, index) => ({
          default: curUrl + defaultImg,
          hover: this.hoverImages[index] ? curUrl + this.hoverImages[index] : curUrl + defaultImg
        }));

        // 2. 如果不足5个，用默认项补全
        while (combined.length < 5) {
          combined.push({
            ...this.defaultItem
          });
        }

        return combined;
      }
    },
    data() {
      return {
        // 默认图片配置
        // defaultItem: {
        //   default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //   hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg'
        // },
        defaultItem: {
          default: '',
          hover: ''
        },
        // 定义模块的内容，每个对象包括静默图片和悬停图片的路径
        // items: [{
        //     default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg',
        //   },
        //   {
        //     default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg',
        //   },
        //   {
        //     default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg',
        //   },
        //   {
        //     default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg',
        //   },
        //   {
        //     default: 'https://s21.ax1x.com/2024/05/09/pkVRgWd.jpg',
        //     hover: 'https://s21.ax1x.com/2024/05/09/pkVRRSA.jpg',
        //   },
        // ],
      };
    },
  };
</script>

<style scoped>
  .image-hover-module {
    /* 改为 Grid 布局 */
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 桌面端每行5列，等宽分布 */
    gap: 1vw;
    /* 确保容器无内外边距，让列直接贴边 */
    margin: 0;
    padding: 0;
  }

  /* 移除 .item 的 width 定义，让 Grid 控制尺寸 */
  .item {
    position: relative;
    /* 原有其他与宽度无关的样式可保留 */
  }

  .image-container {
    position: relative;
    width: 100%;
    height: 30vw;   /* 可根据需要调整 */
    overflow: hidden;
  }

  /* 悬停效果保持不变 */
  .default-img,
  .hover-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    transition: opacity 0.3s ease;
    position: absolute;
  }

  .hover-img {
    opacity: 0;
  }

  .item:hover .hover-img {
    opacity: 1;
  }

  .item:hover .default-img {
    opacity: 0;
  }

  /* 移动端适配：改为每行2列 */
  @media (max-width: 768px) {
    .image-hover-module {
      grid-template-columns: repeat(2, 1fr);
      gap: 4vw;
      padding: 2vw;   /* 可选：为触摸屏留出轻微内边距，不影响“贴边”要求（因为 padding 会收缩内容区域） */
    }
    .image-container {
      height: 70vw;
    }
  }

  /* 小屏幕手机（可选，与移动端保持一致即可） */
  @media (max-width: 480px) {
    .image-hover-module {
      grid-template-columns: repeat(2, 1fr);
      gap: 4vw;
    }
    .image-container {
      height: 70vw;
    }
  }
</style>
